/* eslint-disable react/no-unescaped-entities */
/* eslint-disable sonarjs/no-duplicate-string */

import { NotFoundComponent } from '@modules/core/components/NotFoundComponent';
import { IS_SPAIN_ENV } from '@modules/core/utils';

export const TermsAndConditions = () => {
  if (IS_SPAIN_ENV) {
    return <NotFoundComponent />;
  }

  return (
    <div style={ { padding: '24px' } }>
      <h2
        dir='ltr'
        style={ {
          textAlign: 'center',
          marginBottom: '0pt',
          padding: '0pt 0pt 4pt 0pt',
        } }
      >
        <span
          style={ {
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          TERMS &amp; CONDITIONS
        </span>
      </h2>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Our Platform (as defined below) belongs to the Huspy group of
          companies. The Huspy group is inclusive of Huspy Mortgage Broker FZE,
          which is incorporated in the United Arab Emirates and licensed to
          provide mortgage brokerage services, and its Affiliates (“
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Huspy
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”, “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          us
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”, “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          we
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”, &nbsp;and/or “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          our
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”).
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <br />
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Your use of our Platform and Services (as defined below) will be
          governed by these terms and conditions (“
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Terms and Conditions
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” or “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Terms
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”). It will be your responsibility to periodically review these Terms
          to familiarize yourself with them. By continuing to use our Platform
          and/or the Services, you are agreeing to these Terms (and any
          amendments) in full. You may not use, and will immediately discontinue
          your use of our Platform or Services if you are not able to create a
          legally binding agreement in accordance with applicable laws and/or if
          you do not agree to these Terms in full.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <br />
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'base<Escape>line',
            whiteSpace: 'pre-wrap',
          } }
        >
          We process information about you in accordance with our Privacy
          Policy. By using our Platform, you agree that you have read,
          understood and agree to the Privacy Policy.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <br />
      </p>
      <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 24 } }>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              DEFINITIONS AND INTERPRETATION
            </span>
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              &nbsp;
            </span>
          </p>
        </li>
      </ol>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Affiliate
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means, in relation to a body corporate, any branch, subsidiary or
          holding company of such body corporate, and any branch, subsidiary of
          any such holding company, in each case from time to time.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Client
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means a prospective client seeking a Mortgage.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Client Data
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” means proprietary information and personal data of the Client that
          is non-public data, which may be provided by the User and/or Client to
          Huspy, to enable the provision of the Services.&nbsp;
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Credits
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means online credits that are purchased by the User. Credits are
          considered a form of virtual currency utilized by the User within the
          Platform to enable the User to access and process Services(s) on the
          Platform. For more information on the Credit system, please refer to
          the terms set out on our&nbsp;
        </span>
        <a
          href='https://huspy.dev.huspy.net/ae/content/pricing?_storyblok=543157177&_storyblok_c=HeaderFooterLayout&_storyblok_version=&_storyblok_lang=default&_storyblok_release=0&_storyblok_rl=1726665861847&_storyblok_tk%5Bspace_id%5D=165304&_storyblok_tk%5Btimestamp%5D=1726665861&_storyblok_tk%5Btoken%5D=bc0967148ec66db8e86d0ba3a871a98999c856ac'
          style={ { textDecoration: 'none' } }
        >
          <span
            style={ {
              fontSize: '11pt',
              fontFamily: 'Arial,sans-serif',
              color: '#000000',
              fontWeight: 400,
              fontStyle: 'normal',
              fontVariant: 'normal',
              textDecoration: 'underline',
              WebkitTextDecorationSkip: 'none',
              textDecorationSkipInk: 'none',
              verticalAlign: 'baseline',
              whiteSpace: 'pre-wrap',
            } }
          >
            Credits
          </span>
        </a>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;page.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Data
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          has the meaning given to it in clause 10.1.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Disclosing Party
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” has the meaning given to it in clause 15.2.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Dispute
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” has the meaning given to it in clause 14.2.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Equipment
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” has the meaning given to it in clause 4.5.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Intellectual Property Rights
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means means all design rights, trade marks and service marks (in each
          case whether registered or not), patents, inventions (whether
          patentable or not), registered designs, copyrights, contractual
          waivers of moral rights, rights in databases and collections of data,
          utility models and all similar property rights whether or not
          registered or registrable, designs, drawings, performances, computer
          programs, rights in confidential information, know-how and trade
          secrets (and any documents containing such confidential information,
          know-how or trade secrets), business or brand names, rights in domain
          names, metatags, goodwill or the style or presentation of goods or
          services including applications for protection, renewal or extension
          of any such rights.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Mortgage
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means the mortgage loan sought by a Client from a Mortgage
          Provider.&nbsp;
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Mortgage Application
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means the mortgage application processed by the User for the Client to
          assist the Client in obtaining a Mortgage from a Mortgage Provider.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Platform
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means the platform we provide (mb.huspy.com) whereby the User can
          access the Services as described in more detail herein.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Proprietary Information
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          has the meaning given to it in clause 15.2.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Receiving Party
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” has the meaning given to it in clause 15.2.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Referral Fee
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” has the meaning given to it in clause 8.1.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Representatives
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” means in relation to a party, its Affiliates and without limitation
          each party’s or its respective Affiliates’ directors, officers,
          employees, agents, representatives and/or external legal advisers,
          consultants, contractors and subcontractors, and/or service providers.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Services
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          has the meaning given to it in clause 2, and for the avoidance of
          doubt is inclusive of, without limitation, the Platform and Software.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Service Fees
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          has the meaning given to it in clause 7.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Mortgage Provider
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means third party banks, building societies, financial institutes
          and/or any other financial lenders licensed, regulated and operational
          in the United Arab Emirates, whose products are listed on our
          Platform.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          Software
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means any software, documentation or data related to the Services
          and/or Platform.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          UAE
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means the United Arab Emirates.
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          User
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          means any person who accesses and uses our Services. References
          to&nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “you”&nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          and “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          your
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ”
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          &nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          are to the User
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          .&nbsp;
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          The User categories are as follows:
        </span>
      </p>
      <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'lower-alpha',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              Individual persons: may be (i) independent mortgage brokers /
              consultants running their own mortgage consultation business, or
              (ii) individuals who are employed by corporate mortgage brokers as
              described in paragraph (b) below; or
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'lower-alpha',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              Corporate mortgage brokers: mortgage brokerage company providing
              mortgage brokerage / consultation services to customers in the
              United Arab Emirates. The employees of such User (b) may also be
              granted access to the Services and will be subject to these Terms.
            </span>
          </p>
        </li>
      </ol>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          “
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          User Data
        </span>
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          ” means proprietary information and personal data of the User that is
          non-public data provided by the User to Huspy to enable the provision
          of the Services.&nbsp;
        </span>
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <br />
      </p>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          In these Terms, unless the context otherwise requires:
        </span>
      </p>
      <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'lower-alpha',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              References to a “person” includes any individual, partnership,
              body corporate, corporation sole or aggregate, state or agency of
              a state, and any unincorporated association or organisation, in
              each case whether or not having separate legal personality;
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'lower-alpha',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              words introduced by the word “other” shall not be given a
              restrictive meaning because they are preceded by words referring
              to a particular class of acts, matters or things; and
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'lower-alpha',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              general words shall not be given a restrictive meaning because
              they are followed by words which are particular examples of the
              acts, matters or things covered by the general words and the words
              “includes” and “including” shall be construed without limitation.
            </span>
          </p>
        </li>
      </ol>
      <p
        dir='ltr'
        style={ {
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 2 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              SERVICES AND SUPPORT
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Services provided are inclusive of, without limitation
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  &nbsp;
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Services
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”)
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  :&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#1a202c',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  An online Platform that permits the User:
                </span>
              </p>
              <ol
                style={ {
                  marginTop: 0,
                  marginBottom: 0,
                  paddingInlineStart: 48,
                } }
              >
                <li
                  dir='ltr'
                  style={ {
                    listStyleType: 'decimal',
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre',
                  } }
                  aria-level={ 3 }
                >
                  <p
                    dir='ltr'
                    style={ {
                      textAlign: 'justify',
                      marginTop: '0pt',
                      marginBottom: '0pt',
                    } }
                  >
                    <span
                      style={ {
                        fontSize: '11pt',
                        fontFamily: 'Arial,sans-serif',
                        color: '#000000',
                        fontWeight: 400,
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        textDecoration: 'none',
                        verticalAlign: 'baseline',
                        whiteSpace: 'pre-wrap',
                      } }
                    >
                      to connect with Clients and/or Mortgage Providers to
                      prepare, manage, and complete Mortgage Applications for a
                      Mortgage on behalf of the Client;
                    </span>
                  </p>
                </li>
                <li
                  dir='ltr'
                  style={ {
                    listStyleType: 'decimal',
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre',
                  } }
                  aria-level={ 3 }
                >
                  <p
                    dir='ltr'
                    style={ {
                      textAlign: 'justify',
                      marginTop: '0pt',
                      marginBottom: '0pt',
                    } }
                  >
                    <span
                      style={ {
                        fontSize: '11pt',
                        fontFamily: 'Arial,sans-serif',
                        color: '#000000',
                        fontWeight: 400,
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        textDecoration: 'none',
                        verticalAlign: 'baseline',
                        whiteSpace: 'pre-wrap',
                      } }
                    >
                      to research and compare independent mortgage rates offered
                      by Mortgage Providers, and to aggregate and provide such
                      mortgage rates onto a proposal downloadable by the User
                      that may be shared with Clients. The products, rates and
                      prices displayed on our Platform are not created by us,
                      but are offered by Mortgage Providers over whom we do not
                      exercise any control. &nbsp;The User acknowledges that
                      there may be other products available on the market which
                      are not shown on the Platform and which may be more
                      appropriate or suitable for the User and/or Client than
                      those shown on the Platform. Huspy does not provide any
                      financial, investment or other advice in relation to any
                      products and/or services provided by Mortgage Providers,
                      nor do we provide a recommendation or endorsement of
                      specific Mortgage Providers;
                    </span>
                  </p>
                </li>
                <li
                  dir='ltr'
                  style={ {
                    listStyleType: 'decimal',
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre',
                  } }
                  aria-level={ 3 }
                >
                  <p
                    dir='ltr'
                    style={ {
                      textAlign: 'justify',
                      marginTop: '0pt',
                      marginBottom: '0pt',
                    } }
                  >
                    <span
                      style={ {
                        fontSize: '11pt',
                        fontFamily: 'Arial,sans-serif',
                        color: '#000000',
                        fontWeight: 400,
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        textDecoration: 'none',
                        verticalAlign: 'baseline',
                        whiteSpace: 'pre-wrap',
                      } }
                    >
                      to apply for a Mortgage pre-approval through a Mortgage
                      Application, upload the required documents for the Client
                      and Mortgage Application, and obtain a digital format of
                      the Mortgage pre-approval from the Mortgage Provider; and
                    </span>
                  </p>
                </li>
                <li
                  dir='ltr'
                  style={ {
                    listStyleType: 'decimal',
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre',
                  } }
                  aria-level={ 3 }
                >
                  <p
                    dir='ltr'
                    style={ {
                      textAlign: 'justify',
                      marginTop: '0pt',
                      marginBottom: '0pt',
                    } }
                  >
                    <span
                      style={ {
                        fontSize: '11pt',
                        fontFamily: 'Arial,sans-serif',
                        color: '#000000',
                        fontWeight: 400,
                        fontStyle: 'normal',
                        fontVariant: 'normal',
                        textDecoration: 'none',
                        verticalAlign: 'baseline',
                        whiteSpace: 'pre-wrap',
                      } }
                    >
                      to submit a Mortgage Application to the Mortgage Provider
                      through (i) Huspy’s brokerage business, or (ii) the User’s
                      business directly. Referral Fees differ depending on the
                      method chosen by the User.&nbsp;
                    </span>
                  </p>
                </li>
              </ol>
            </li>
          </ol>
        </li>
      </ol>
      <p
        dir='ltr'
        style={ {
          marginLeft: '72pt',
          textAlign: 'justify',
          marginTop: '0pt',
          marginBottom: '0pt',
        } }
      >
        <span
          style={ {
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre-wrap',
          } }
        >
          If applicable to the User’s case, administrative assistance with, and
          consultation throughout, the Mortgage Application process, including
          without limitation:&nbsp;
        </span>
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 5 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
            marginLeft: '72pt',
          } }
          aria-level={ 3 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              the property valuation process, in order to obtain the property
              valuation report for submission to the Mortgage Provider;
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
            marginLeft: '72pt',
          } }
          aria-level={ 3 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              final Mortgage offer letter requests from the Mortgage Provider
              and execution of the letter by the Client;
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
            marginLeft: '72pt',
          } }
          aria-level={ 3 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              collation of Customer Data and final document / information
              required for the Mortgage Application to be submitted to the
              Mortgage Provider; and
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
            marginLeft: '72pt',
          } }
          aria-level={ 3 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              Monitoring the Mortgage disbursement process to promote transfer
              of the Mortgage to the Client.
            </span>
          </p>
        </li>
      </ol>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 3 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
            marginLeft: '36pt',
          } }
          aria-level={ 2 }
        >
          <p
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '10pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              Subject to the Terms, we will use commercially reasonable efforts
              to provide the User with the Services and reasonable technical
              support services at our sole discretion. You acknowledge and agree
              that we will have no obligation to provide you with any support or
              maintenance in connection with our Platform or your use thereof.
              We also cannot guarantee that there will be no &nbsp;viruses,
              worms, Trojan horses, or other malicious code or harmful
              components embedded in our Platform which could adversely affect
              the device you are accessing it from. It will be your sole
              responsibility to ensure that your device is adequately protected
              against such threats.
            </span>
          </p>
        </li>
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 700,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <h3
            dir='ltr'
            style={ {
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              CREATING AN ACCOUNT WITH US
            </span>
          </h3>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  As part of the registration process, the User will identify an
                  administrative user name and password for its Platform
                  account. &nbsp;Huspy reserves the right to, and in its sole
                  discretion may, refuse registration of, suspend, delete,
                  deactivate and/or cancel accounts and/or passwords.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You will be responsible for ensuring the accuracy of the
                  information you submit when creating an account with us. All
                  information provided by you must be provided in good faith.
                  Such information must be true and accurate in all material
                  respects and not misleading as of the date such information is
                  given. You should also revise this information regularly to
                  check that the information we have for you is correct. We
                  reserve the right to remove or suspend accounts that are not
                  truthful. We will not be liable for any costs, expenses or
                  liabilities incurred by you due to inaccurate information.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  All information and interactions you make through your account
                  or through your use of our Services must be appropriate,
                  factual, and remain professional at all times. You must at all
                  times (i) comply with applicable laws, rules and regulations,
                  (ii) not infringe on any intellectual or proprietary rights of
                  any third party, (iii) not submit, provide, promote, or
                  display information that is inaccurate, false or misleading in
                  any way whatsoever, including but not limited to,
                  impersonating or purporting to impersonate any other person,
                  (v) not be offensive, illegal or inappropriate in any way, and
                  (vi) not infringe on any rights of any third party and/or
                  restrict or inhibit such third parties’, Clients’, other
                  Users’, and/or Mortgage Providers’ use and enjoyment of the
                  Services and Platform.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You are responsible for keeping your login information secret
                  and secure at all times. You hereby agree not to permit any
                  other person to use your username and password and not to
                  disclose or provide any other person your username, your
                  password or any other information that may allow any other
                  person to gain access to your account. You will remain
                  responsible and liable for all activity that occurs through or
                  is associated with your account. You may not use the account
                  of anyone else or set-up more than one account for yourself
                  (especially if your account has been suspended or deactivated
                  by us for any reason).&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 4 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              USER RESTRICTIONS AND RESPONSIBILITIES&nbsp;
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  If required under applicable laws, the User agrees that it
                  has, or will obtain as/when required, all valid licences,
                  registrations and authorisations to enable the User to carry
                  out its business and/or to process Mortgage Applications in
                  the United Arab Emirates.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User will not directly or indirectly: reverse engineer,
                  decompile, disassemble or otherwise attempt to discover the
                  source code, object code or underlying structure, ideas,
                  know-how or algorithms relevant to the Services; modify,
                  translate, or create derivative works based on the Services
                  (except to the extent expressly permitted by Huspy or
                  authorized within the Services); use the Services for the
                  benefit of a third party; or remove any proprietary notices or
                  labels.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User will not access our Services in order to build a
                  similar product or create competitive Services.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  No part of our Services may be copied, modified, reproduced,
                  distributed, republished, downloaded, displayed, posted or
                  transmitted in any form or by any means, including but not
                  limited to linked, framed, hyperlinked or deep-linked into any
                  other platform (except to the extent expressly permitted by
                  Huspy or authorized within the Services).
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User will be responsible for obtaining and maintaining any
                  equipment and ancillary services needed to connect to, access
                  or otherwise use the Services, including, without limitation,
                  modems, hardware, servers, software, operating systems,
                  networking, web servers and the like (collectively, “
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Equipment
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”). &nbsp;The User will also be responsible for maintaining
                  the security of the Equipment, User account, passwords
                  (including but not limited to administrative and user
                  passwords) and files, and for all uses of User account or the
                  Equipment with or without the User’s knowledge or consent.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User may not at any time during its use of Huspy’s
                  Services: (i) harass or abuse other Users and/or third
                  parties, whether by threatening, stalking, spamming,
                  transmitting junk mail, chain mail and/or any other form of
                  harassment and/or abuse; (ii) violate the privacy of other
                  Users and/or third parties, either by infringing applicable
                  privacy laws, soliciting personally identifiable information
                  for the purposes of harassment, exploitation, commercial
                  activities, promotional activities, or any other reason which
                  is contrary to the reason such information was obtained; (iii)
                  unfairly interfere with any other User’s or third party’s
                  uninterrupted use and enjoyment of the Services; (iv) upload,
                  transmit, or introduce any viruses, worms, Trojan horses, or
                  other malicious code or harmful components into the Services
                  or our systems; (v) engage in any activity that disrupts,
                  disables, damages, or impairs the functionality or performance
                  of the Services or our systems, including but not limited to
                  hacking, denial of service attacks, or other similar
                  disruptive activities; (vi) disrupt, interfere with, or
                  otherwise harm or violate the security of our Services, system
                  resources, accounts, passwords, servers or networks connected
                  to or accessible through our Services.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User represents, covenants, and warrants that it will use
                  the Services only in compliance with these Terms, Huspy’s
                  requirements as published on the Platform, and all applicable
                  laws and regulations. The User hereby agrees to indemnify,
                  defend, and hold harmless Huspy, its group companies and
                  Affiliates, and their respective directors, officers,
                  employees, agents, advisers and representatives, from and
                  against any and all claims, damages, losses, liabilities,
                  settlements and expenses (including without limitation costs
                  and attorneys’ fees) arising out of or relating to: (a) any
                  breach of User’s representations, warranties, or obligations
                  under these Terms; (b) any violation of applicable laws or
                  regulations by the User or its Representatives; (c) any use of
                  the Services by the User or its Representatives that is not in
                  accordance with these Terms; and (d) any negligence or willful
                  misconduct by the User or its Representatives. Although we
                  have no obligation to monitor Users’ use of the Services, we
                  may do so and may prohibit any User access to the Services if
                  we believe there may be (or alleged to be) a violation of the
                  Terms. We reserve our right, at your expense, to assume the
                  exclusive defense and control of any matter for which you are
                  required to indemnify us, and you agree to fully cooperate
                  with us with regards thereto and not to settle any matter
                  without our prior written consent. We will use reasonable
                  efforts to notify you of any such claim, action or proceeding
                  upon becoming aware of it.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You hereby release and discharge us and our Affiliates
                  indefinitely, and our and their respective representatives,
                  successors and assigns (as applicable) from and against each
                  and every past, present and future dispute, claim,
                  controversy, demand, right, obligation, liability, action and
                  cause of action of every kind (including personal injuries,
                  death, and property damage) that has arisen or arises directly
                  or indirectly, in whole or in part, out of your use of our
                  Services.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 5 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              SUBMISSION OF MORTGAGE REQUESTS BY USER
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User will be responsible for conducting KYC and AML
                  screening on Clients that are seeking a Mortgage. This
                  includes without limitation reviewing, verifying, and
                  validating the Client and documents submitted to the User by
                  the Client to determine if such Client is eligible for a
                  Mortgage. &nbsp;Aspects of the Services and the Mortgage
                  Provider’s products will be determined by the information you
                  provide when using the Services. It is therefore very
                  important that you answer all questions truthfully, completely
                  and accurately and that you disclose all relevant facts. It is
                  your responsibility to identify and correct any mistakes or
                  errors in the information, content, material or data before
                  you obtain any product from a Mortgage Provider. Failure to do
                  so could invalidate the Services and/or Mortgage Providers’
                  products made available to you.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User is responsible for obtaining the necessary consents
                  and permission from the Client to register and process the
                  Client’s Mortgage Application through Huspy’s Platform. Huspy
                  will, at its sole discretion, determine if the Client’s
                  Mortgage Application shall be accepted on Huspy’s
                  Platform.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The User is responsible for ensuring that the Client is made
                  aware that the Client’s Mortgage Application is processed
                  through the Huspy Platform and, if applicable, through Huspy’s
                  brokerage business.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Subject to the remainder of this clause 5, the User will be
                  solely responsible for all communications (including any
                  queries or questions raised) with the Client.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Huspy agrees that it shall not have any direct contact with
                  Clients outside the scope of the provision of Services on the
                  Platform, unless (i) agreed by the parties involved in the
                  relevant Mortgage Application process, (ii) the Client
                  specifically requests to contact Huspy for any reason, (iii)
                  the Client is approaching Huspy to raise a complaint and/or
                  flag a breach of the Terms by the User, (iv) a Mortgage
                  Provider has requested Huspy to contact a Client, and/or (v)
                  Huspy is required to do so under applicable laws and/or at the
                  request of a government and/or regulatory authority. Subject
                  to the foregoing, if the Client contacts Huspy in relation to
                  a Mortgage Application, Huspy will redirect the Client to the
                  User that has submitted such application.&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 6 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              INTELLECTUAL PROPERTY
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Huspy will own and retain all right, title and interest in and
                  to (a) the Services, Platform and Software, and all
                  improvements, enhancements or modifications thereto, (b) any
                  software, applications, inventions or other technology
                  developed in connection with the Services or support, and (c)
                  all Intellectual Property Rights related to any of the
                  foregoing. No rights or licenses are granted except as
                  expressly set forth herein.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You acknowledge and agree that any and all Intellectual
                  Property Rights, including, without limitation, those relating
                  to our Services, Platform, Software and content surrounding
                  the foregoing are owned and will be owned by us, or, if
                  applicable in relation to products listed on our Platform, our
                  Mortgage Providers (as applicable). Neither these Terms, nor
                  your access to or use of our Platform or the Services, will
                  transfer to you or any third party, any rights, title or
                  interest in or to such Intellectual Property Rights, except
                  for the limited access and licensing rights set out in these
                  Terms. We reserve all of our rights not granted in these Terms
                  and reserve the same for our third party providers. There are
                  no implied licenses granted under these Terms or by your use
                  of our Services.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Subject to the remainder of these Terms, Huspy hereby grants
                  you a non-transferable, non-exclusive, revocable, limited
                  license to use and access our Services in accordance with
                  these Terms, but reserve our right to revoke any or all of
                  such authorizations at any time.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 7 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              PAYMENT OF SERVICE FEES
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You agree to pay any fees and/or other charges incurred by you
                  throughout your usage of the Services &nbsp;in accordance with
                  any fee, credit, and/or payment provisions set out in the
                  Terms and/or Platform, including without limitation terms set
                  out on our&nbsp;
                </span>
                <a
                  href='https://huspy.dev.huspy.net/ae/content/pricing?_storyblok=543157177&_storyblok_c=HeaderFooterLayout&_storyblok_version=&_storyblok_lang=default&_storyblok_release=0&_storyblok_rl=1726665861847&_storyblok_tk%5Bspace_id%5D=165304&_storyblok_tk%5Btimestamp%5D=1726665861&_storyblok_tk%5Btoken%5D=bc0967148ec66db8e86d0ba3a871a98999c856ac'
                  style={ { textDecoration: 'none' } }
                >
                  <span
                    style={ {
                      fontSize: '11pt',
                      fontFamily: 'Arial,sans-serif',
                      color: '#000000',
                      fontWeight: 400,
                      fontStyle: 'normal',
                      fontVariant: 'normal',
                      textDecoration: 'underline',
                      WebkitTextDecorationSkip: 'none',
                      textDecorationSkipInk: 'none',
                      verticalAlign: 'baseline',
                      whiteSpace: 'pre-wrap',
                    } }
                  >
                    Credits
                  </span>
                </a>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  &nbsp;page (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Service Fees
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”).&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  You will be required to purchase Credits from our Platform,
                  via the payment methods provided, which can be used /
                  exchanged in part or in full to avail of the options of
                  Services. Payment methods other than those stated on the
                  Platform will not be accepted. You will be responsible for the
                  payment of all taxes associated with your use of the Services
                  and/or the transactions completed and submitted through your
                  account on our Platform. &nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  If your usage of the Services exceeds the available Credits on
                  your account, you will be unable to process the relevant
                  Service to completion. Credits cannot be reimbursed once
                  purchased, so it is important to ensure that each User is
                  considering their Services needs accordingly.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Huspy reserves the right to change the Service Fees and to
                  institute new charges and Service Fees at its discretion upon
                  a 15 days prior notice to the User (which may be sent by
                  email). If the User believes that Huspy has billed the User
                  incorrectly, the User must contact Huspy no later than 30 days
                  after the closing date of the relevant Service transaction in
                  which the error or problem appeared in order to receive an
                  adjustment to the User’s Credits if the error is proven.&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 8 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              PAYMENT OF REFERRAL FEE
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The parties agree that Huspy will pay the User a referral fee
                  as agreed between the parties in accordance with any payment
                  provisions set out in the Terms, Platform and/or Huspy’s
                  latest email correspondence with the User related to this
                  subject matter (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Referral Fee
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”).&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 9 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              THIRD PARTY TERMS OF SERVICE
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Certain features of our Platform or the Services will be
                  subject to additional terms and conditions of third parties
                  and Mortgage Providers. It will be your responsibility to
                  inform yourself and your Client of such third party’s and/or
                  Mortgage Provider’s terms and conditions before availing of
                  Services from Huspy. Terms and conditions may differ from one
                  Mortgage Provider to another and may be amended without prior
                  notice to you. Such terms and conditions will form an integral
                  part of these Terms and any such third party and/or Mortgage
                  Provider will have the right to enforce such terms and
                  conditions against you. We do not under any circumstances
                  guarantee the accuracy, reliability, quality, availability or
                  sustainability of any third party and/or Mortgage Provider or
                  the services, product, and/or data provided by them.&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 10 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              DATA SHARING
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  As between Huspy and the User, the User is the data controller
                  and will own (or have the permission and/or license to use)
                  all right, title and interest in and to the User Data and
                  Client Data, as well as any data that is based on or derived
                  from the User Data and Client Data and provided to the User as
                  part of the Services (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Data
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”). You understand and acknowledge that we may share the Data
                  with third parties and/or Mortgage Providers to enables us and
                  such parties to provide the Services and that we require such
                  third parties to handle the Data in a confidential manner and
                  to not disclose it to such parties except as required and to
                  the extent necessary for the purposes of the Services.
                  However, you acknowledge and agree that we are not responsible
                  and will not be held liable in the event any Data is disclosed
                  by such third parties. The handling of any personal data by
                  Huspy will be in accordance with the terms of the Privacy
                  Policy.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Notwithstanding anything to the contrary, Huspy will have the
                  right to collect and analyze data and other information
                  relating to the provision, use and performance of various
                  aspects of the Services, Platform, Software and related
                  systems and technologies (including, without limitation,
                  information concerning the Data), and Huspy will be free
                  (during and after the term hereof) to (i) use such information
                  and data to improve and enhance the Services and for other
                  development, diagnostic and corrective purposes in connection
                  with the Services and other Huspy offerings, and (ii) disclose
                  such data solely in aggregate or other de-identified form in
                  connection with its business.&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 11 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              WARRANTY AND DISCLAIMERS
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Huspy will use reasonable efforts consistent with prevailing
                  industry standards to maintain the Services in a manner which
                  minimizes errors and interruptions in the Services and will
                  perform the Services in a professional and workmanlike manner.
                  &nbsp;Services may be temporarily unavailable for scheduled
                  maintenance or for unscheduled emergency maintenance, either
                  by Huspy or by third-party providers, or because of other
                  causes beyond Huspy’s reasonable control, but Huspy will use
                  reasonable efforts to provide advance notice in writing or by
                  e-mail of any scheduled service disruption. &nbsp;HOWEVER,
                  HUSPY DOES NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED
                  OR ERROR FREE; NOR DOES IT MAKE ANY WARRANTY AS TO THE RESULTS
                  THAT MAY BE OBTAINED FROM USE OF THE SERVICES. &nbsp;EXCEPT AS
                  EXPRESSLY SET FORTH IN THIS SECTION, THE SERVICES ARE PROVIDED
                  “AS IS” AND COMPANY DISCLAIMS ALL WARRANTIES, EXPRESS OR
                  IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF
                  MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE AND
                  NON-INFRINGEMENT.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 12 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              LIMITATION ON LIABILITY
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  To the maximum extent permitted by applicable laws, and
                  notwithstanding anything to the contrary, except for bodily
                  injury of a person, Huspy and its service providers (including
                  but not limited to lenders, all equipment and technology
                  suppliers), officers, Affiliates, representatives,
                  contractors, advisers and employees will not be responsible or
                  liable with respect to any subject matter of these Terms or
                  any conditions related thereto under any contract, negligence,
                  strict liability or other theory: (a) for error or
                  interruption of use or for loss or inaccuracy or corruption of
                  data or cost of procurement of substitute goods, services or
                  technology or loss of business; (b) for any indirect,
                  exemplary, incidental, special or consequential damages; (c)
                  for any matter beyond Huspy’s reasonable control; or (d) for
                  any amounts that, together with amounts associated with all
                  other claims, exceed the Service Fees paid by the User to
                  Huspy for the Services under this agreement in the 12 months
                  prior to the act that gave rise to the liability, in each
                  case, whether or not Huspy has been advised of the possibility
                  of such damages. Access to, and your use of our Platform or
                  the Services, will be strictly at your own risk.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 13 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              TERM AND TERMINATION
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  These Terms will remain in full force and effect at all times
                  during your use of our Services and/or your access to our
                  Platform. We may suspend or terminate your rights to use our
                  Services and/or access our Platform at any time for any reason
                  at our sole discretion. The User may terminate their account
                  on the Platform by emailing their Huspy account manager and
                  requesting a deactivation of the account.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Upon termination any account you may have with us and any
                  right to access our Platform, use our Services and/or your
                  remaining Credits will be terminated immediately. If there are
                  any Mortgage Applications still pending on your account upon
                  termination, Huspy will use commercially reasonable efforts to
                  conclude the transactions with the Client and Mortgage
                  Provider on behalf of the User. You will remain entitled to
                  your Referral Fee following a successfully dispersed Mortgage
                  to your Client if the termination of your account was not due
                  to a breach of these Terms and/or applicable law. We will not
                  be liable in any way whatsoever for any termination of your
                  rights under these Terms or loss of access to your account on
                  the Platform due to a termination. &nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  All sections of these Terms which by their nature should
                  survive termination will survive termination, including,
                  without limitation, accrued rights to payment, confidentiality
                  obligations, warranty and disclaimers, and limitations of
                  liability. All other terms will survive the termination of
                  your account with us for a period of five (5) years from the
                  date you last visited our Platform.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 14 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              GOVERNING LAW AND DISPUTE RESOLUTION
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  These Terms and Conditions will be governed and construed in
                  accordance with the laws of the Dubai International Financial
                  Centre (DIFC), Dubai, United Arab Emirates.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Subject to the remainder of this clause, in the event of any
                  dispute, difference, claim, controversy or question among the
                  parties, directly or indirectly, arising at any time under,
                  out of, in connection with or in relation to the Terms or any
                  term, condition or provision hereof, including, without
                  limitation, any of the same relating to the existence,
                  validity, interpretation, construction, performance,
                  enforcement and termination of their agreements (a “
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Dispute
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”), the parties shall first endeavour an amicable settlement
                  by good faith consultation and negotiation.&nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  If the parties fail to reach such settlement within one month,
                  the User agrees that such Dispute shall be finally settled in
                  accordance with the rules of the Dubai International
                  Arbitration Centre (DIAC) (which rules are deemed incorporated
                  by reference in these Terms). The arbitration shall be
                  conducted by an arbitration tribunal consisting of three
                  arbitrators appointed in accordance with the rules of the
                  DIAC. The arbitration shall take place in the English language
                  and the seat shall be the DIFC, in Dubai, United Arab
                  Emirates. Judgment for any award rendered may be entered in
                  any court having jurisdiction or an application may be made to
                  such court for a judicial recognition of the award or an order
                  of enforcement thereof, as the case may be. The arbitration
                  proceedings contemplated by this clause and the content of any
                  award rendered in connection with such proceedings shall be
                  kept confidential by the parties.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  In respect of breaches by the User under these Terms, Huspy
                  shall have the option, exercisable at its sole discretion, to
                  commence legal proceedings in whatsoever jurisdiction it may
                  deem appropriate. Nothing in this clause shall preclude and/or
                  prohibit Huspy from seeking provisional measures to secure its
                  rights from any court having jurisdiction or where any assets
                  of the other party may be found.
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
      <p>
        <br />
      </p>
      <ol
        style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }
        start={ 15 }
      >
        <li
          dir='ltr'
          style={ {
            listStyleType: 'decimal',
            fontSize: '11pt',
            fontFamily: 'Arial,sans-serif',
            color: '#000000',
            fontWeight: 400,
            fontStyle: 'normal',
            fontVariant: 'normal',
            textDecoration: 'none',
            verticalAlign: 'baseline',
            whiteSpace: 'pre',
          } }
          aria-level={ 1 }
        >
          <p
            dir='ltr'
            style={ {
              lineHeight: '1.38',
              textAlign: 'justify',
              marginTop: '0pt',
              marginBottom: '0pt',
            } }
          >
            <span
              style={ {
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 700,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre-wrap',
              } }
            >
              GENERAL
            </span>
          </p>
          <ol style={ { marginTop: 0, marginBottom: 0, paddingInlineStart: 48 } }>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Territory.&nbsp;
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  The Services are intended for access to products and/or
                  services in the United Arab Emirates. If you choose to use the
                  Services from locations outside the United Arab Emirates, you
                  do so at your sole risk.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Confidentiality.&nbsp;
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Each party (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Receiving Party
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”) understands that the other party (“
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Disclosing Party
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ”) has disclosed or may disclose business, technical or
                  financial information relating to the Disclosing Party’s
                  business (hereinafter referred to as “
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Proprietary Information
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  ” of the Disclosing Party). Proprietary Information of Huspy
                  includes non-public information regarding features,
                  functionality and performance of the Services.
                  &nbsp;Proprietary Information of the User includes non-public
                  data provided by the User to Huspy to enable the provision of
                  the Services. The Receiving Party agrees: (i) to take
                  reasonable precautions to protect such Proprietary
                  Information, and (ii) not to use (except in performance of the
                  Services or as otherwise permitted herein) or divulge to any
                  third person any such Proprietary Information. &nbsp;The
                  Disclosing Party agrees that the foregoing will not apply with
                  respect to any information that the Receiving Party can
                  document (a) is or becomes generally available to the public,
                  or (b) was in its possession or known by it prior to receipt
                  from the Disclosing Party, or (c) was rightfully disclosed to
                  it without restriction by a third party, or (d) was
                  independently developed without use of any Proprietary
                  Information of the Disclosing Party or (e) is required to be
                  disclosed by law. &nbsp;
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Electronic Communications.&nbsp;
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  All communications between us and you will be in electronic
                  form. For contractual purposes, you (i) consent to receive
                  communications from us in an electronic form and (ii) you
                  agree that all terms and conditions, agreements, notices,
                  disclosures, and other forms of communication that we may
                  provide you with, satisfy any legal requirement that such
                  communications would satisfy if they were be in a hardcopy.
                  The foregoing does not affect any non-waivable rights.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Entire Agreement.&nbsp;
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  These Terms, together with our Privacy Policy, constitute the
                  entire agreement between us and you regarding the use of our
                  Services. Our failure to exercise or enforce any right or
                  provision of these Terms will not operate as a waiver of such
                  right or provision. The section titles in these Terms are for
                  convenience only and have no legal or contractual effect. Any
                  or all of the rights and limitations set forth in these Terms
                  may be waived by the party against whom the claim is asserted.
                  Such waiver will not waive or affect any other portion of
                  these Terms. If any part or parts of these Terms are found
                  under the law to be invalid or unenforceable by a court of
                  competent jurisdiction, then such specific part or parts will
                  be of no force and effect and will be severed and the
                  remainder of these Terms will continue in full force and
                  effect. These Terms, and your rights and obligations herein,
                  may not be assigned, subcontracted, delegated, or otherwise
                  transferred by you without our prior written consent, and any
                  attempted assignment, subcontract, delegation, or transfer in
                  violation of the foregoing will be null and void. We may
                  freely assign these Terms at our sole and absolute discretion.
                  The terms and conditions set forth in these Terms will be
                  binding upon assignees.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Modifications.
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  &nbsp;You should review these Terms on a routine and periodic
                  basis as we reserve our right, at any time and without prior
                  notice to you, to suspend or discontinue our Services, whether
                  in whole or in part, and delete any accounts in relation
                  thereto, and to amend or modify these Terms to reflect changes
                  in technology, payment methods, relevant laws and regulatory
                  requirements, our system's capabilities or features, and
                  market conditions affecting our business. Without limiting the
                  generality of the foregoing, these Terms (as may be amended
                  from time to time) will apply and will continue to apply each
                  and every time you open an account with us, avail or book a
                  Service through our Platform and/or otherwise access our
                  Platform and Services for any reason.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Copyright &amp; Trademark Information
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  . All trademarks, logos and service marks displayed on our
                  Platform and in relation thereto are our property or the
                  property of other third parties. You are not permitted to use
                  them without our prior written consent or the consent of such
                  third party that may own the Marks.
                </span>
              </p>
            </li>
            <li
              dir='ltr'
              style={ {
                listStyleType: 'decimal',
                fontSize: '11pt',
                fontFamily: 'Arial,sans-serif',
                color: '#000000',
                fontWeight: 400,
                fontStyle: 'normal',
                fontVariant: 'normal',
                textDecoration: 'none',
                verticalAlign: 'baseline',
                whiteSpace: 'pre',
              } }
              aria-level={ 2 }
            >
              <p
                dir='ltr'
                style={ {
                  lineHeight: '1.38',
                  textAlign: 'justify',
                  marginTop: '0pt',
                  marginBottom: '0pt',
                } }
              >
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 700,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  Contact
                </span>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  . If you have any questions about these Terms or would like to
                  contact us for any other reason, you can contact us by post at
                  7th Floor, The Bay Gate, Business Bay, Dubai, United Arab
                  Emirates, or by email at&nbsp;
                </span>
                <a
                  href='mailto:contact@huspy.io'
                  style={ { textDecoration: 'none' } }
                >
                  <span
                    style={ {
                      fontSize: '11pt',
                      fontFamily: 'Arial,sans-serif',
                      color: '#000000',
                      fontWeight: 400,
                      fontStyle: 'normal',
                      fontVariant: 'normal',
                      textDecoration: 'underline',
                      WebkitTextDecorationSkip: 'none',
                      textDecorationSkipInk: 'none',
                      verticalAlign: 'baseline',
                      whiteSpace: 'pre-wrap',
                    } }
                  >
                    contact@huspy.io
                  </span>
                </a>
                <span
                  style={ {
                    fontSize: '11pt',
                    fontFamily: 'Arial,sans-serif',
                    color: '#000000',
                    fontWeight: 400,
                    fontStyle: 'normal',
                    fontVariant: 'normal',
                    textDecoration: 'none',
                    verticalAlign: 'baseline',
                    whiteSpace: 'pre-wrap',
                  } }
                >
                  , or contact your relevant account manager.&nbsp;
                </span>
              </p>
            </li>
          </ol>
        </li>
      </ol>
    </div>
  );
};
